'use client';

import type { User } from 'next-auth';
import type {
  CallContractResponse,
  SendRawTransactionResponse,
  SignMessageResponse,
} from '../services/walletService';
import messageChannelStore from '../stores/messageChannelStore';
import {
  MESSAGE_TYPE,
  type MessageType,
} from './message-handlers/messageHandlers';
import { onInitChannel } from './message-handlers/onInitChannel';
import { isOnPing, onPing } from './message-handlers/onPing';
import type { WalletMessageEvent } from './types';

class WalletMessageChannel {
  connectionResolve: ((value: User) => void) | undefined;
  connectionReject: ((reason?: string) => void) | undefined;

  signMessageResolve: ((value: SignMessageResponse) => void) | undefined;
  callContractResolve: ((value: CallContractResponse) => void) | undefined;
  sendRawTransactionResolve:
    | ((value: SendRawTransactionResponse) => void)
    | undefined;

  requestReject: ((reason?: string) => void) | undefined;

  init() {
    window.addEventListener(
      'message',
      (event: WalletMessageEvent<MessageType, unknown>) => {
        if (isOnPing(event)) {
          onPing(event);
        }

        if (
          event.data.type === MESSAGE_TYPE.INIT_CHANNEL &&
          event.ports &&
          event.ports[0]
        ) {
          onInitChannel(event);
        }
      }
    );
  }

  sendToMain(msg: unknown) {
    const { messagePort } = messageChannelStore.getState();
    if (messagePort) {
      messagePort.postMessage(msg);
    } else {
      // Channel not established
    }
  }
}

export default new WalletMessageChannel();
